import { startingStyle, endingStyle } from "./TransitionStatusDataAttributes.js";
const STARTING_HOOK = {
  [startingStyle]: ""
};
const ENDING_HOOK = {
  [endingStyle]: ""
};
const transitionStatusMapping = {
  transitionStatus(value) {
    if (value === "starting") {
      return STARTING_HOOK;
    }
    if (value === "ending") {
      return ENDING_HOOK;
    }
    return null;
  }
};
export {
  transitionStatusMapping
};
//# sourceMappingURL=stateAttributesMapping.js.map
